import React from 'react';
import { Box, Typography } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <Typography>読み込み中...</Typography>
    </Box>
  );
};

export default LoadingSpinner;